import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'react-bootstrap/Table';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomPagination from '../../CustomPagination';
import Loader from '../../../components/Common/Loader';
import CurrencyModal from './CurrencyModal';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import debounce from '../../../helpers/debounce';
import messages from '../../../locale/messages';
import { updateCurrencyStatus, setBaseCurrency, allowPaymentCurrency, removeCurrency, updatePayoutCurrency } from '../../../actions/siteadmin/Currency/updateCurrency';
import { openCurrencyModal } from '../../../actions/siteadmin/modalActions';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';
import { demoRestriction } from '../../../actions/demoRestriction';
import bt from '../../../components/commonStyle.css';
import s from './CurrencyList.css';


const CurrencyList = ({ CurrencyData, refetch, loading }) => {
	const [currentPage, setCurrentPage] = useState(1)
	const intl = useIntl()
	const dispatch = useDispatch()
	const base = useSelector((state) => state?.currency?.base)

	const handleKeywordSearch = useCallback(debounce((searchList) => {
		let variables = {
			currentPage: 1,
			searchList: searchList
		}
		refetch(variables)
	}), [])

	const handleUpdateStatus = useCallback(async (id, status, symbol) => {
		let variables = { currentPage };
		const isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		await dispatch(updateCurrencyStatus(id, status, symbol));
		refetch(variables);
	}, [])

	const handleBaseCurrency = useCallback(async (id) => {
		let variables = { currentPage };
		const isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		await dispatch(setBaseCurrency(id));
		refetch(variables);
	}, [])

	const managePaymentCurrency = async (id, isPayment) => {
		const isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		await dispatch(allowPaymentCurrency(id, isPayment));
		refetch();
	}

	const handlePayoutCurrency = useCallback(async ({ id, isPayoutCurrency, symbol }) => {
		const isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		await dispatch(updatePayoutCurrency({ id, isPayoutCurrency, symbol }));
		refetch();
	}, [])

	const handleDelete = useCallback(async (id, symbol) => {
		const isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		if (base == symbol) {
			showToaster({ messageId: 'failedDeleteCurrency', toasterType: 'error' });
			return;
		}
		let variables, page;
		page = await getCurrentPage({ results: CurrencyData?.getCurrency?.results, page: currentPage });
		variables = { currentPage: page };
		const response = await dispatch(removeCurrency(id, symbol));
		if (response?.status == 200) {
			setCurrentPage(page)
			refetch(variables)
		}
	}, [])

	const paginationData = useCallback((currentPage) => {
		let variables = { currentPage };
		setCurrentPage(currentPage);
		refetch(variables);
	}, [])

	return (
		<div>
			<div className={s.exportDisplay}>
				<div className={s.searchGroupContainer}>
					<div className={cx(s.searchInput, 'searchInputRTL')}>
						<FormControl type='text' placeholder={intl.formatMessage(messages.searchOnly)} onChange={(event) => handleKeywordSearch(event.target && event.target.value)} className={bt.formControlInput} />
					</div>
				</div>
				<div className={cx(s.exportTextSection)}>
					<Button
						className={cx(bt.btnPrimary)}
						onClick={() => dispatch(openCurrencyModal())}
					>
						<FormattedMessage {...messages.addNewLabel} />
					</Button>
				</div>
			</div>
			<CurrencyModal />
			<div className="clearfix"></div>

			{
				loading && <div>
					<Loader type="circle" />
				</div>
			}
			{!loading &&
				<div className={'tableOuterContainer'}>
					<Table className="tableContainer">
						<thead>
							<tr>
								<th scope="col"><FormattedMessage {...messages.id} /></th>
								<th scope="col"><FormattedMessage {...messages.symbol} /></th>
								<th scope="col"><FormattedMessage {...messages.baseCurrency} /></th>
								<th scope="col"><FormattedMessage {...messages.status} /></th>
								<th scope="col"><FormattedMessage {...messages.enableDisable} /></th>
								<th scope="col"><FormattedMessage {...messages.setBaseCurrency} /></th>
								<th scope="col"><FormattedMessage {...messages.allowedPaymentCurrency} /></th>
								<th scope="col"><FormattedMessage {...messages.payoutCurrency} /></th>
								<th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
							</tr>
						</thead>
						<tbody>
							{
								CurrencyData?.getCurrency?.results && CurrencyData?.getCurrency?.results?.length > 0 && CurrencyData?.getCurrency?.results?.map((item, index) => {
									return (
										<tr key={index}>
											<td data-label={intl.formatMessage(messages.id)}>{item.id}</td>
											<td data-label={intl.formatMessage(messages.symbol)}>{item.symbol}</td>
											{item.isBaseCurrency == 1 && <td data-label={intl.formatMessage(messages.baseCurrency)}><FormattedMessage {...messages.active} /></td>}
											{item.isBaseCurrency == 0 && <td data-label={intl.formatMessage(messages.baseCurrency)}></td>}
											{item.isEnable && <td data-label={intl.formatMessage(messages.status)}><FormattedMessage {...messages.Enabled} /></td>}
											{!item.isEnable && <td data-label={intl.formatMessage(messages.status)}><FormattedMessage {...messages.Disabled} /></td>}
											<td data-label={intl.formatMessage(messages.enableDisable)}>
												<div>
													<a href="javascript:void(0)" onClick={() => handleUpdateStatus(item.id, item.isEnable, item.symbol)} className="actionLinkText">
														{
															item.isEnable && <span> <FormattedMessage {...messages.Disable} /> </span>
														}

														{
															!item.isEnable && <span> <FormattedMessage {...messages.Enable} /> </span>
														}
													</a>
												</div>
											</td>
											<td data-label={intl.formatMessage(messages.setBaseCurrency)}>
												<div>
													{
														!item.isBaseCurrency && item.isEnable && <a href="javascript:void(0)" onClick={() => handleBaseCurrency(item.id)} className="actionLinkText">
															<FormattedMessage {...messages.setBase} />
														</a>
													}
												</div>
											</td>
											<td data-label={intl.formatMessage(messages.allowedPaymentCurrency)}>

												<span>
													{
														<a href="javascript:void(0)" onClick={() => managePaymentCurrency(item?.id, item?.isPayment)}>
															{item?.isPayment ? intl.formatMessage(messages.remove) : intl.formatMessage(messages.addLabel)}
														</a>
													}
												</span>
											</td>
											<td data-label={intl.formatMessage(messages.payoutCurrency)}>
												<div>
													{
														!item.isPayoutCurrency && item.isEnable && <a href="javascript:void(0)" onClick={() => handlePayoutCurrency({ id: item?.id, isPayoutCurrency: item?.isPayoutCurrency, symbol: item?.symbol })} className="actionLinkText">
															<FormattedMessage {...messages.setPayoutCurrency} />
														</a>
													}
													{
														item.isPayoutCurrency && <FormattedMessage {...messages.active} />
													}
												</div>
											</td>
											<td data-label={intl.formatMessage(messages.deleteAction)}>
												<div>
													<Button onClick={() => handleDelete(item.id, item.symbol)} className={s.iconBtn}>
														<CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
														<span className={cx(s.vtrMiddle)}>
															<FormattedMessage {...messages.deleteAction} />
														</span>
													</Button>
												</div>
											</td>
										</tr>
									)
								})
							}
							{
								!loading && CurrencyData?.getCurrency?.results?.length == 0 && (
									<tr>
										<td colspan="12" className={'tableNoRecordCel'}><FormattedMessage {...messages.noResult} /></td>
									</tr>
								)
							}
						</tbody>
					</Table>
				</div>
			}
			{
				CurrencyData?.getCurrency?.results && CurrencyData?.getCurrency?.results?.length > 0
				&& <div className={cx(bt.space5, bt.spaceTop5)}>
					<CustomPagination
						total={CurrencyData.getCurrency.count}
						currentPage={currentPage}
						defaultCurrent={1}
						defaultPageSize={10}
						change={paginationData}
						paginationLabel={intl.formatMessage(messages.currencies)}
					/>
				</div>
			}
		</div >
	)
}
export default withStyles(bt, s)(CurrencyList)